const initialState = {};

const SiteSetReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SITE_DATA_SET': {
      return action.payload;
    }

    default:
      return state;
  }
};

export default SiteSetReducer;
